import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader'; // Sidebar yerine Header'ı import ediyoruz

const AdminLayout = () => {
  return (
    <div className="admin-wrapper">
      <AdminHeader />
      <main className="admin-main-content">
        <div className="container-fluid">
          <Outlet /> {/* Sayfalarınız artık burada render edilecek */}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;